import { Button, Div } from '@codesuma/baseline'
import { SheetPage } from '../../components/sheet-page'
import { toFaDigits } from '../../helpers/digits'
import widget from '../../services/widget'
import style from './index.module.css'

// How the card gets onto a home screen.
//
// Android can do it: the launcher takes the request, asks the user to confirm,
// and pins it — one tap from here. iOS gives an app no way to add its own
// widget at all, and some Android launchers decline too, so the steps by hand
// are always there as the answer for everyone else.

const STEPS = [
    'روی جای خالی صفحهٔ خانه انگشت خود را نگه دارید.',
    'گزینهٔ ویجت‌ها یا + را بزنید.',
    'در فهرست، «امروز» را پیدا کنید و آن را روی صفحه بگذارید.',
]

const platform = () => (window as any).Capacitor?.getPlatform?.() || 'web'

export const WidgetPage = () => {
    const base = SheetPage('ویجت امروز')

    const desc = Div('روز، ماه و رویدادهای امروز، روی صفحهٔ خانه — بی‌آنکه برنامه را باز کنید.')
    desc.addClass(style.desc)
    base.append(desc)

    // Only worth saying when it is true, so it starts empty and fills in if the
    // answer comes back yes. Someone who already has one is not asked again.
    const note = Div()
    note.addClass(style.note)
    base.append(note)
    widget.installed().then(has => {
        if (has) note.text('ویجت امروز روی صفحهٔ خانهٔ شماست.')
    })

    const steps = Div()
    steps.addClass(style.steps)
    STEPS.forEach((text, i) => {
        const row = Div()
        row.addClass(style.step)
        const number = Div(toFaDigits(i + 1))
        number.addClass(style.number)
        const label = Div(text)
        label.addClass(style.label)
        row.append(number, label)
        steps.append(row)
    })

    if (platform() === 'android') {
        // Held back until it is needed: on a launcher that can pin, the button
        // is the whole story and three steps underneath it are just noise.
        steps.addClass(style.held)
        const add = Button('افزودن به صفحهٔ خانه')
        add.addClass(style.add)
        add.el.onclick = async () => {
            const supported = await widget.pin()
            if (!supported) steps.removeClass(style.held)
        }
        base.append(add)
    }

    base.append(steps)
    return base
}
